import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const CategoryPills = ({ categories, activeCategory, setActiveCategory }) => {
  const { t, tCategory } = useLanguage();
  
  const activeLabel = activeCategory === 'all' 
    ? t('all') 
    : categories.find(c => c.id === activeCategory)?.emoji + ' ' + tCategory(activeCategory);
  
  return (
    <div className="mx-4 md:mx-8 lg:mx-16 mt-4">
      <Select value={activeCategory} onValueChange={setActiveCategory}>
        <SelectTrigger className="w-full max-w-xs bg-white border-2 border-[#0a1628]/20 text-[#0a1628] rounded-xl py-6 px-4 font-bold text-base hover:border-[#0a1628]/40 transition-all">
          <SelectValue placeholder="Select Category">
            {activeLabel}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-white border-[#0a1628]/20 rounded-xl">
          {categories.map((category) => (
            <SelectItem 
              key={category.id} 
              value={category.id}
              className="text-[#0a1628] font-medium py-3 cursor-pointer hover:bg-[#0a1628]/10"
            >
              <span className="flex items-center gap-2">
                <span className="text-lg">{category.emoji}</span>
                {category.id === 'all' ? t('all') : tCategory(category.id)}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CategoryPills;
